type Props = { size?: number; color?: string; fill?: string };

export function IconHeart({
	size = 18,
	color = "currentColor",
	fill = "none",
}: Props) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill={fill}
			stroke={color}
			strokeWidth="2"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<path d="M12 20.5l-1.5-1.4C6 15 3.5 12.7 3.5 9.6A4.6 4.6 0 0 1 12 7a4.6 4.6 0 0 1 8.5 2.6c0 3.1-2.5 5.4-7 9.5z" />
		</svg>
	);
}
